/**
 * Shared @dnd-kit sensors + a helper to convert drag-end events into
 * (fromIdx, toIdx) ready for the draft hook's move callbacks.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  type DragEndEvent,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

export function useBinomDragSensors() {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
}

/**
 * Returns the from/to indices of a sort drag-end, or null when it was a no-op
 * (over=null or same id).
 */
export function dragEndToMove(
  event: DragEndEvent,
  ids: string[],
): { from: number; to: number } | null {
  const { active, over } = event;
  if (!over || active.id === over.id) return null;
  const from = ids.indexOf(String(active.id));
  const to = ids.indexOf(String(over.id));
  if (from < 0 || to < 0) return null;
  return { from, to };
}
